<template>
    <div>
        <ul v-if="chats.length" id="people-list" class="friendz-list">
            <li v-for="(chat,index) in chats" :key="chat.id" @click="openChat(chat)">
                <figure>
                    <img :src="extractUser(chat.users).avatar"/>
                    <span :class="{'status':true,'f-online':extractUser(chat.users).online}"></span>
                </figure>
                <div class="friendz-meta">
                    <a href="#">{{ extractUser(chat.users).name }}</a>
                    <p v-if="chat.latest_message">
                        {{ chat.latest_message.text.substring(0,15) + "..." }}
                    </p>
                </div>
            </li>
        </ul>
        <p v-else class="no-request-message">{{text.no_new_request}}</p>
    </div>
</template>

<script>
    import VueCookies from 'vue-cookies'

    export default {
        name: "chat-requests",

        props: ['userId'],

        data() {
            return {
                chats: [],
                word: window.word,
                text: window.text,
            };
        },

        methods: {
            openChat(chat) {
                Vue.$cookies.set('active_chat_id', chat.id);
                window.location.href = '/dashboard/my-chats';
            },
            fetchChats() {
                axios.get('/dashboard/chats?only_requests')
                    .then(response => {
                        this.chats = response.data.data;
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
            listenForNewEvents() {
                if (echoEnabled) {
                    Echo.private('users.' + this.userId)
                        .listen('ChatCreated', chat => {
                            this.chats.unshift(chat);
                        })
                        .listen('ChatViewed', chat => {
                            this.chats = this.chats.find(item => item.id !== chat.id);
                        })
                        .listen('NewMessage', message => {
                            this.updateLatestMessage(message);
                        });
                }
            },
            extractUser(users) {
                return users.find(user => {
                    return user.id !== this.userId
                });
            },
            updateLatestMessage(message) {
                this.chats.map(chat => {
                    if (chat.id === message.chat.id) {
                        chat.latest_message = message
                    }
                });
            }
        },

        mounted() {
            this.fetchChats();
            this.listenForNewEvents();
        },
    }
</script>

<style scoped>
    .no-request-message {
        text-align: left;
        font-size: 13px;
        color: #666;
        padding: 45px 20px 5px 20px;
    }
</style>
